//libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.div<{
  isFiltersExpanded: boolean;
}>`
  width: 100%;
  display: flex;
  height: min-content;
  flex-direction: ${({ isFiltersExpanded }) => (isFiltersExpanded ? 'column-reverse' : 'row')};
  justify-content: space-between;
  ${({ isFiltersExpanded }) => !isFiltersExpanded && 'padding-bottom:0'};
`;

export const SortContainer = styled.div<{ isFiltersExpanded: boolean; isSticky: boolean }>`
  ${({ isFiltersExpanded }) => isFiltersExpanded && 'align-self:flex-end'};
  margin-left: auto;
  padding-bottom: ${({ theme, isSticky, isFiltersExpanded }) => {
    if (isFiltersExpanded) return theme.spacing.spacing80;
    if (isSticky) return 0;
    return theme.spacing.spacing80;
  }};
`;
